import { useEffect, useState } from 'react';

import { PrimaryButton } from '@changegps/horizon-component-library';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export const AppNotFoundPage = ({ path = '/home' }: { path?: string }) => {
  const navigate = useNavigate();

  const [seconds, setSeconds] = useState<number>(10);

  const redirectPath = path;

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds((prev) => prev - 1);
    }, 1000);

    const timeout = setTimeout(() => {
      navigate(redirectPath);
    }, seconds * 1000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [navigate, redirectPath, seconds]);

  return (
    <Box sx={{ pt: 2, pl: 3, bgcolor: '#FFF', height: '100%' }}>
      <Typography fontWeight={600} fontSize={28} gutterBottom>
        404 - Page Not Found
      </Typography>
      <Typography fontSize={16} color="text.secondary" mb={2}>
        The page you&apos;re looking for doesn&apos;t exist.
      </Typography>
      <Typography fontSize={16} color="text.secondary" mb={4}>
        You&apos;ll be automatically redirected to your product&apos;s main page
        in <strong>{seconds}</strong> second{seconds !== 1 ? 's' : ''}.
        <br />
        Or click the button below to go immediately.
      </Typography>

      <PrimaryButton onClick={() => navigate(redirectPath)}>
        Return to Main Screen
      </PrimaryButton>
    </Box>
  );
};
